/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { Row, Col, Table, Empty, Input, Popconfirm, message, DatePicker } from 'antd'
import { Link } from 'react-router-dom'
import _ from 'lodash'
import moment from 'moment'
import { observer, inject } from 'mobx-react'
import { compose } from 'recompose'
import { Query, graphql } from 'react-apollo'
import gql from 'graphql-tag'
import { RoleCode } from '../../../../constants'

import AddForm from './addForm'
import ViewCertificate from '../../viewCertificate'
import UserNameLabel from '../../../../components/Custom/UserNameLabel'
import SubscribeProgress from '../../subscribeProgress'

const { RangePicker } = DatePicker
const dateFormat = 'll'

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
			page: 1,
			pageSize: 10,
			searchText: '',
			sortOrder: null,
			sortName: null,
			isAddFormShown: false,
			isEdit: false,
			selectedCertificate: null,
			IsViewCertificateShown: false,
			certificateUrl: null,
			dateRange: [],
			isExporting: false,
			exportProgress: null
		}
        
		this.handleOnChange = this.handleOnChange.bind(this)
	}
    
	handleOnChange(pagination, filters, sorter) {
		this.setState({
			page: pagination.current,
			pageSize: pagination.pageSize,
			sortOrder: (sorter.order === 'ascend') ? 'asc' : 'desc',
			sortName: sorter.field,
			// complain_status: filters.status,
		})
	}

	render() {
		const { AuthStore } = this.props
		const { barangay_uid, user_type, user_uid } = AuthStore
		const isAdmin = _.isEqual(RoleCode.SYSTEMADMIN, user_type) || _.isEqual(RoleCode.SUPERADMIN, user_type)
		const { page, pageSize, sortOrder, sortName, searchText,
			isAddFormShown, isEdit, selectedCertificate,
			IsViewCertificateShown, certificateUrl, dateRange = [], isExporting, exportProgress
		} = this.state
		let filters = { 
			page, pageSize, searchText, sortOrder, sortName
		}
		if (dateRange.length > 0) {
			const startDate = moment(dateRange[0]).format('YYYY-MM-DD HH:mm:ss')
			const endDate = moment(dateRange[1]).format('YYYY-MM-DD HH:mm:ss')
			filters = Object.assign({}, filters, {
				date_start: startDate,
				date_end: endDate
			})
		}

		const certificate_name = 'certificate-kin'
		return (
			<Row type='flex' justify='center'>
				<Col md={24} sm={24}>
					<Row>
						<button type="button" className="btn btn-primary btn-rounded waves-effect waves-light" onClick={() => {
							this.setState({ isAddFormShown: true, isEdit: false, selectedCertificate: null })
						}} style={{ float: 'right' }}>New Certificate</button>
						<Input placeholder='Search Here' style={{ width: 230, float: 'right', marginRight: 20, marginTop: 5 }} onChange={(e) => {
							this.setState({ searchText: e.target.value })
						}}/>
						{
							isAdmin &&
							<RangePicker
								format={dateFormat}
								style={{ marginRight: 20, marginTop: 5, width: 400, float: 'right' }}
								onChange={(value) => {
									// console.log('range picker value', value)
									this.setState({ dateRange: value })
								}}
							/>
						}
						{
							(isAdmin && (dateRange.length > 0)) &&
							<button 
								type="button" 
								className="btn btn-outline-success btn-rounded waves-effect waves-light"
								onClick={() => {
									const { exportCertificate } = this.props
									const params = {
										certificate_name,
										date_start: moment(dateRange[0]).format('YYYY-MM-DD'),
										date_end: moment(dateRange[1]).format('YYYY-MM-DD'),
										searchText
									}
									exportCertificate(params)
								}}
							>
								<i className='mdi mdi-file-excel'/> Export in Excel
							</button>
						}
					</Row>
					<br />
					<Row>
						<Query query={CERTIFICATE} variables={{ searchFilter: filters, barangay_uid }}>
							{({ loading, error, data, subscribeToMore }) => {
								if (error) return <Empty/>

								let certificates = _.has(data,'allCertificateKin') ? data.allCertificateKin.data : []
								certificates = certificates.map((certificate, key) => Object.assign({}, certificate, { key }))
								let _pagination = _.has(data, 'allCertificateKin') ? data.allCertificateKin.pagination : {}
								_pagination = Object.assign({}, _pagination, {
									pageSizeOptions: ['10', '25', '50'],
									showSizeChanger: true,
									total: _.has(_pagination, 'rowCount') ? _pagination.rowCount : 0,
									showTotal: (total) => `Total ${total} items`
								})

								const columns = [{
									title: '#',
									key: 'control_number',
									dataIndex: 'control_number'
								}, {
									title: 'Name',
									key: 'name',
									dataIndex: 'name'
								}, {
									title: 'Request Date',
									key: 'request_date',
									render: (record) => {
										return (
											<span>{moment(record.request_date).format('ll')}</span>
										)
									}
								}, {
									title: 'OR Number',
									key: 'or_number',
									dataIndex: 'or_number'
								}, {
									title: 'Amount',
									key: 'amount',
									dataIndex: 'amount',
									visible: isAdmin
								}, {
									title: 'Issued By',
									key: 'created_by',
									render: (record) => {
										return <UserNameLabel user_uid={record.created_by} />
									}
								}, {
									title: 'Action',
									key: 'action',
									width: 200,
									render: (record) => {
										return (
											<React.Fragment>
												<a href="#" onClick={(e) => {
													e.preventDefault()
													// window.open(`${process.env.REACT_APP_BACKEND_API}${record.file_url}`, '_blank')
													this.setState({ IsViewCertificateShown: true, certificateUrl: `${process.env.REACT_APP_BACKEND_API}${record.file_url}` })
												}}>View Certificate</a>
												{
													isAdmin &&
													<Popconfirm
														title="Are you sure delete this certificate?"
														onConfirm={() => {
															const { deleteCertificate } = this.props
															deleteCertificate(record.uid).then((response) => {
																message.success('Certificate successfully deleted.')

																//create audit trail
																const auditParams = {
																	module_name: 'Certificate',
																	action: 'Delete',
																	message: `Deleted Certificate of Next of Kin of ${record.name}`
																}
																AuthStore.saveAuditTrail(auditParams)
															}).catch(err => {
																console.log('error deleting certificate', err)
																message.error(err.message.replace('GraphQL error:', ''))
															})
														}}
														// onCancel={cancel}
														okText="Yes"
														cancelText="No"
													>
														<a style={{ marginLeft: 10 }} href="#">Delete</a>
													</Popconfirm>
												}
											</React.Fragment>
										)
									}
								}]
								return (
									<Row>
										<Row style={{ marginBottom: 10 }}>
											<SubscribeProgress
												exportProgress={exportProgress}
												isExporting={isExporting}
												subscribeToExportProgress={() => {
													subscribeToMore({
														document: EXPORT_PROGRESS,
														variables: { user_uid, process_name: certificate_name },
														updateQuery: (prev, { subscriptionData }) => {
															// console.log('[NEW_MESSAGE] previous value', prev)
															// console.log('[NEW_MESSAGE] subscriptionData value', subscriptionData)
															if (_.isEqual(subscriptionData.data.exportProgress.status, 'exporting')) {
																this.setState({ isExporting: true, exportProgress: subscriptionData.data.exportProgress })
															} else {
																this.setState({ isExporting: false, exportProgress: null })
															}
														}
													})
												}}
											/>
										</Row>
										<Row>
											<Table 
												loading={loading}
												columns={columns} 
												dataSource={certificates} 
												bordered
												onChange={this.handleOnChange}
												pagination={_pagination}
												scroll={{ x: 1020 }}
											/>
										</Row>
									</Row>
								)
							}}
						</Query>
					</Row>
					{
						isAddFormShown &&
                        <AddForm
                        	isEdit={isEdit}
                        	selectedCertificate={selectedCertificate}
                        	visible={isAddFormShown}
                        	onClose={() => this.setState({ isAddFormShown: false, isEdit: false, selectedCertificate: null })}
                        />
					}

					{
						IsViewCertificateShown &&
						<ViewCertificate 
							certificate_url={certificateUrl}
							visible={IsViewCertificateShown}
							onCancel={() => this.setState({ IsViewCertificateShown: false, certificateUrl: null })}
						/>
					}
				</Col>
			</Row>
		)
	}
}

const CERTIFICATE = gql`
    query allCertificateKin($barangay_uid: String, $searchFilter: SearchParams) {
		allCertificateKin(barangay_uid: $barangay_uid, searchFilter: $searchFilter)
    }
`

const DELETE_CERTIFICATE = gql`
    mutation deleteCertificate($certificate_uid: String, $certificate_type: String) {
		deleteCertificate(certificate_uid: $certificate_uid, certificate_type: $certificate_type)
    }
`

const EXPORT_PROGRESS = gql`
	subscription exportProgress($user_uid: String, $process_name: String) {
		exportProgress(user_uid: $user_uid, process_name: $process_name)
	}
`

const EXPORT_CERTIFICATE = gql`
    mutation exportCertificate($input: JSON) {
		exportCertificate(input: $input)
    }
`

const composed = compose(
	inject('AuthStore'),
	graphql(DELETE_CERTIFICATE, {
		props({ mutate }) {
			return {
				deleteCertificate(certificate_uid) {
					return mutate({
						variables: { certificate_uid, certificate_type: 'kin' },
					  	refetchQueries: ['allCertificateKin']
					})
				}
			}
		}
	}),
	graphql(EXPORT_CERTIFICATE, {
		props({ mutate }) {
			return {
				exportCertificate(params) {
					return mutate({
						variables: { input: params },
					  	// refetchQueries: ['visitorLogs']
					})
				}
			}
		}
	}),
	observer
)

export default composed(Index)
